// extracted by mini-css-extract-plugin
module.exports = {"Rating":"Rating_Rating__3S4Iv","Star":"Rating_Star__1MuC-","StarSelected":"Rating_StarSelected__1jrnK","Label":"Rating_Label__1_wc4"};